import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import axios from "axios";
import PropertyCard from "./propertycard";

import discoverTroyButton from "../assect/images/buttons/discovertroy.jpg"

export default function AvailableProperties(){
    const [properties, setProperties] = useState([]);

    //const apiPath = 'https://dimoralivingwebapi.azurewebsites.net/dimoraproperties/ListRandomProperties';

    const apiPath = 'https://dimoraliving.com/dimoraproperties/ListRandomProperties';
    
    const fetchData = async (apiPostPath) => {

        try {

            // grab data from api and place into state
            const response = await axios.get(apiPostPath);
            const data = response.data;
            const newArray = [...data];
            setProperties(newArray);

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() =>{
        fetchData(apiPath);
    }, [])    
    
    return (
        <>
            <div className="align-items-center"> <p style={{color: "#b65741", fontSize:"14pt", textAlign:"center"}}>AVAILABLE PROPERTIES</p></div>
            <div className="row g-4 mt-0">
                <div className="col-lg-8">
                    <div className="row g-4">
                        {properties.length === 0 ? <span className="loader"></span> :
                            properties.map((item, index) => {
                                return (
                                    <PropertyCard item={item} key={index}/>
                                )
                            })}                        
                    </div>
                </div>
                <div className="col-lg-4">
                    <Link to="/discovertroy">
                        <img src={discoverTroyButton} alt="Discover Troy" width="212" height="158" />                    
                    </Link>
                </div>
            </div>
        </>
    )
}